import { Card, CardBody, Col } from "reactstrap";
import DashboardCommonHeader from "../../../CommonComponents/DashboardCommonHeader/DashboardCommonHeader";
import { OrderOverviewTitle, TotalRevenue } from "../../../../Constants/Constants";
import { H2, H5, H6, ProgressBar } from "../../../../AbstractElements";
import { OrderOverviewData } from "../../../../Data/General/Widgets/General";

const OrderOverview = () => {
  return (
    <Col xxl="3" md="6" className="box-col-6">
      <Card className="order-overview">
        <DashboardCommonHeader title={OrderOverviewTitle} dropdownClass="dropdown-toggle" />
        <CardBody>
          <div className="d-flex">
            <H2 className="me-2">($3,512,201)</H2>
            <H5>{TotalRevenue}</H5>
          </div>
          {OrderOverviewData.map((item, index) => (
            <div className="total-revenue" key={index}>
              <div className="d-flex">
                <H6 className="me-2">{item.value}</H6>
                <span>({item.title})</span>
              </div>
              <ProgressBar className={`bg-light-${item.color}`} color={item.color} value={item.value}/>
            </div>
          ))}
        </CardBody>
      </Card>
    </Col>
  );
};

export default OrderOverview;
